import { xBaseTheme } from "@eisinc/XDL/types";

export default { defaultProps: {} } as xBaseTheme["lists"];
